import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    portalConfiguration: { logoPortal: "" },
    sessionId: null,
    jwt: null,
    token: 1234,
    tokenExpired: null,
    firstname: null,
    lastname: null,
    isAuthentified: false,
    currentUser: { Permissions: [] },
    errorNotificationEnabled: false,
    errorNotificationMessage: "",
  },
  mutations: {
    setPortalConfiguration(state, config) {
      state.portalConfiguration = config;
    },
    setJwt(state, jwtToken) {
      state.jwt = jwtToken;
    },
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
      state.isAuthentified = false;
    },
    setToken(state, token) {
      state.token = token;
    },
    setTokenExpired(state, isExpired) {
      state.tokenExpired = isExpired;
    },
    setFirstname(state, firstname) {
      state.firstname = firstname;
    },
    setLastname(state, lastname) {
      state.lastname = lastname;
    },
    setIsAuthentified(state, bool) {
      state.isAuthentified = bool;
    },
    setErrorNotificationStatus(state, bool) {
      state.errorNotificationEnabled = bool;
    },
    setNewErrorMessage(state, message) {
      state.errorNotificationEnabled = true;
      state.errorNotificationMessage = message;
    },
  },
  actions: {},
  modules: {},
});
